module.exports = __webpack_public_path__ + "img/q_bg.6d5cc430.png";